import { useForm } from "@corets/use-form"
import { ChangeEvent, KeyboardEvent } from "react"
import { useHistory } from "react-router"
import { WPlus } from "../../../../../assets/images"
import { links } from "../../../../../config/links"
import { createSearchReflectionSourceForm, SearchReflectionSourceFormType } from "./createSearchReflectionSourceForm"

export type SearchReflectionSourceFormProps = {
  onSubmit: (data: SearchReflectionSourceFormType) => void
  defaultValue: SearchReflectionSourceFormType
}
export const SearchReflectionSourceForm = (props: SearchReflectionSourceFormProps) => {
  const { onSubmit, defaultValue } = props
  const history = useHistory()

  const [form] = useForm(createSearchReflectionSourceForm(defaultValue), [defaultValue])

  const handleSubmit = async () => {
    const data = await form.get()
    onSubmit(data)
  }

  const handleChangeFormValue = (event: ChangeEvent<HTMLInputElement>, field: string) => {
    const value = event.target.value
    form.setAt(field, value)
    if (!value) {
      handleSubmit()
    }
  }

  const handleKeyEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit()
    }
  }

  return (
    <form>
      <div className="form-row flex-wrap">
        <div className="form-group mb-0 col-lg-8">
          <input
            value={form.getAt("keyword") || ""}
            onChange={(event) => handleChangeFormValue(event, "keyword")}
            className="form-control"
            placeholder="Tìm theo tên"
            onKeyDown={handleKeyEnter}
          />
        </div>

        <div className="form__save-ct">
          <div className="form__save border-top-0 pt-0 mt-0 justify-content-start">
            <button className="btn btn-ct btn-primary-ct" type="button" onClick={handleSubmit}>
              Tìm kiếm
            </button>
            <button
              className="btn  btn-ct  btn-add btn-danger-ct  d-flex align-items-center"
              type="button"
              onClick={() => history.push(links.category.createReflectionSource())}
            >
              Thêm nguồn phản ánh
              <img src={WPlus} alt="" />
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}
